import React from 'react';
import { StarIcon, HalfStarIcon } from "../utils/icons";

const Rating = ({ star = 5, ...props }) => {
  const starInt = Math.floor(star);
  const halfable = starInt !== star;

  return (
    <ul className="rating" {...props}>
      <style jsx global>{`
        .rating {
          display: inline-flex;
          font-size: 15px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .rating .star-empty path {
          fill: #E3E3E3;
        }
      `}</style>
      {star <= 5 ? (
        <>
          {Array.from(Array(starInt), (_, index) => (
            <StarIcon className="star-full" key={`${index}fs`} />
          ))}
          {halfable && (
            <HalfStarIcon className="star-half" />
          )}
          {Array.from(Array(5 - starInt - (halfable ? 1 : 0)), (_, index) => (
            <StarIcon className="star-empty" key={`${index}es`} />
          ))}
        </>
      ) : null}
    </ul>
  );
};

export default Rating;
